import { parse, ParsedQs } from 'qs';

export function searchStringToObj(searchStr?: string | null): ParsedQs {
  if (!searchStr) {
    return {};
  }
  if (searchStr[0] === '?') {
    // The search string includes the ?, but qs.parse() expects `key=value`, so if there is a
    // query string, we slice off the question mark.
    searchStr = searchStr.slice(1);
  }
  return parse(searchStr);
}
